<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-impressum"></div>
    </div>
    <div class="additional-content">
      <ng-container *ngFor="let header of additionalInfoHeaderList; let index = index">
        <mat-expansion-panel [expanded]="header.expanded" (opened)="header.expanded=true"
          (closed)="header.expanded=false" hideToggle="true">
          <mat-expansion-panel-header class="content-background--mix" collapsedHeight="*" expandedHeight="*">
            <mat-panel-title>
              <div [class.expanded]="header.expanded" class="inline-icon subItemExpand-icon"
                inlineSVG="shop-icons.svg#ya-expand_more">
              </div>
              <span>{{header.label}}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngIf="header.id==headerLabel.Description">
            <div class="content-list">
              <div class="content-list__item--detail">
                <div class="content-list-treat-p-as-element" innerHtml="{{description}}">
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="header.id==headerLabel.Overview">
            <div class="content-list">
              <div class="content-list__item--detail">
                <div class="content-level-info">
                  <ng-container *ngIf="productDetails.item_caffeine>0">
                    <span>{{CaffeinelevelText}}</span>
                  </ng-container>
                  <ng-container *ngIf="productDetails.item_alcohol>0">
                    <span>{{AlcohollevelText}}</span>
                  </ng-container>
                </div>
                <ng-container *ngIf="hasBaseUnit">
                  <div class="base-content-info">
                    <span>{{baseUnit}}</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="hasItemProviderName ||hasItemProviderAddr">
                  <div class="provider-info">
                    <ng-container *ngIf="hasItemProviderName">
                      <div class="provider-info--detail" [innerHtml]="providerName">
                      </div>
                    </ng-container>
                    <ng-container *ngIf="hasItemProviderAddr">
                      <div class="provider-info--detail" [innerHtml]="providerAddr">
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="header.id==headerLabel.CO2">
            <div class="content-list">
              <div class="content-list__item--detail">
                <span>{{productDetails.co2}}g CO<sub>2</sub></span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="header.id==headerLabel.Additives">
            <div class="content-list">
              <div class="content-list__item--detail">
                <div class="content-list-treat-p-as-element" innerHtml="{{additives}}"></div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="header.id==headerLabel.Allergens">
            <div class="content-list">
              <div class="content-list__item--detail">
                <div class="content-list-treat-p-as-element" innerHtml="{{allergens}}"></div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="header.id==headerLabel.Content">
            <div class="content-list">
              <div class="content-list__item--detail">
                <div class="content-list-treat-p-as-element" innerHtml="{{content}}"></div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="header.id ===headerLabel.Nutritions">
            <div class="content-list">
              <div class="content-list__item--header">
                <div class="nutrition nutrition__header">
                  <div class="nutrition-title">
                    <span langkey=phProductDetail_AdditionalInformations></span>
                  </div>
                  <div class="nutrition-value">
                    {{nutritions.header}}<span class="content-list__footnotemark">*</span>
                  </div>
                </div>
              </div>
              <ng-container *ngFor="let nutritionItem of nutritions.nutritionItemViewModels">
                <div class="content-list__item--header nutrition__item--header">
                  <div class="nutrition">
                    <div class="nutrition-title">
                      {{nutritionItem.title}}
                    </div>
                    <div class="nutrition-value">
                      {{nutritionItem.value}}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </mat-expansion-panel>
      </ng-container>
    </div>
    <div class="content-footnote">
      * <span langkey="phProductDetail_InfosNotForCustomizedOrders_TEXT"></span>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-container">
        <button mat-flat-button (click)="dismissDialog()">
          <span langkey="phGlobal_Continue"></span>
        </button>
      </div>
    </div>
  </div>
</div>